import ApiService from "./api.service";
import {TokenService} from "./storage.service";


const MAIN = 'warehouses';
const PREFIX = 'warehouse-document';
const ITEM_PREFIX = 'wh-document-item';
const PRICING_ITEM = 'pricing-item';
const ORDER_DOCUMENT = 'order-document'


const WhDocument = {

	/** Warehouse Documents **/
	getItemsForDepBySaleTypeRetail(payload) {
		return ApiService.get(`/item/wh-search-for-dep/retail/${payload.keyword}/${payload.depId}`);
	},
	getItemsForDepBySaleTypeRetailOff(payload) {
		return ApiService.get(`/item/wh-search-for-dep/write-off/retail/${payload.keyword}/${payload.depId}`);
	},
	getItemsWithBarcodeForDepBySaleTypeRetail(payload) {
		return ApiService.get(`/item/wh-search-for-dep/barcode/retail/${payload.keyword}/${payload.depId}`);
	},
	getItemsForDepBySaleTypeWhole(payload) {
		return ApiService.get(`/item/wh-search-for-dep/whole/${payload.keyword}/${payload.depId}`);
	},
	getItemsForDepBySaleTypeWholeOff(payload) {
		return ApiService.get(`/item/wh-search-for-dep/write-off/whole/${payload.keyword}/${payload.depId}`);
	},
	getDeparmentForDocument(id) {
		return ApiService.get(PREFIX + '/get/department-for-documents/' + id)
	},
	getErrorSales() {
		return ApiService.get(`/sale/responseEmptyKKMCountWithDepWithCashbox`)
	},
	editTransferDoc(id, payload) {
		return ApiService.post(PREFIX + '/edit/transfer-document/' + id, payload)
	},
	editWholeSaleDoc(id, payload) {
		return ApiService.post('sale/edit/nakladnoy/' + id, payload)
	},
	store: function (data) {
		return ApiService.post(PREFIX + '/create', data)
	},
	clearInventory: function (payload) {
		return ApiService.post(PREFIX + '/clear-inventory-list', payload)
	},
	editPrixodWithList(payload) {
		return ApiService.post(PREFIX + '/edit-prixod/with-list', payload)
	},
	clearWhDocument() {
		return ApiService.get(PREFIX + `/clear-inventory-list`);
	},
	update(data) {
		return ApiService.post(PREFIX + `/receive/${data.id}`, {})
	},
	search: (data, section = 'kirim') => {
		return ApiService.post(`${PREFIX}/search/${section}`, data)
	},
	search2: (data) => {
		return ApiService.post(`${PREFIX}/search/kirim/extra-cost`, data)
	},
	searchManualKirim: (data) => {
		return ApiService.post(`${PREFIX}/search/manual-kirim`, data)
	},
	searchTransferKirim: (data) => {
		return ApiService.post(`${PREFIX}/search/transfer-kirim`, data)
	},
	remove(id) {
		return ApiService.delete(`${PREFIX}/delete/${id}`)
	},
	setTemporaryQty(item) {
		return ApiService.post(`${ITEM_PREFIX}/update/transfer-doc/temporary-qty`, item)
	},
	get(id) {
		return ApiService.get(`${PREFIX}/get/${id}`,{})
	},
	saveAndFinishIncomeDoc(docId) {
		return ApiService.post(`/warehouse-document/changeDocStatus/${docId}`)
	},
	getPrices(date) {
		return ApiService.post(`/currency-rate/allByDate`, date)
	},
	Recount(id, data) {
		return ApiService.post(`${PREFIX}/change/income-doc-status/to-recount/${id}`,data)
	},
	aktCreate(id, data) {
		return ApiService.post(`${PREFIX}/akt/create/${id}`, data)
	},
	saveAkt(id, reason) {
		return ApiService.post(`${PREFIX}/akt/approve/${id}?reason=${reason}`)
	},
	cancelAkt(id, reason) {
		return ApiService.post(`${PREFIX}/akt/reject/${id}?reason=${reason}`)
	},
	saveCheckingNakladnoy(id) {
		return ApiService.put(`${PREFIX}/update/doc-to-added-extra-costs/${id}`)
	},
	getPendingList(id, payload) {
		return ApiService.post(`${PREFIX}/get-transfer/${id}`, payload)
	},
	getConfirmMessagePending(id) {
		return ApiService.get(`${PREFIX}/receive/check/transfer-pending-doc/${id}`)
	},
	savePendingPrinyat(id) {
		return ApiService.post(`${PREFIX}/receive/transfer-pending-doc/${id}`)
	},
	savePendingPartial(id) {
		return ApiService.post(`${PREFIX}/receive/partial/transfer-pending-doc/${id}`)
	},
	saveDocWriteOff(data) {
		return ApiService.post(`${PREFIX}/write-off`, data)
	},
	getWithPrices(id, data) {
		return ApiService.post(`${PREFIX}/get/with-prices/${id}`, data)
	},
	getWithTransfersPrices(id, data) {
		return ApiService.post(`${PREFIX}/get-transfers/with-prices/${id}`, data)
	},
	getRequestById(documentId) {
		return ApiService.post(`/request/data/document/${documentId}`);
	},
	searchKeywordRequestItems(keyword) {
		return ApiService.post(`/request/search-keyword/${keyword}`);
	},
	getAktListWithSearch(data) {
		return ApiService.post(`${PREFIX}/akt/search`, data)
	},
	getRequestTransferCreateList(payload) {
		return ApiService.post(`request-for-dutyfree/list/with-remaining/from/item-statuses`, payload)
	},
	createRequestDoc(data) {
		return ApiService.post(`request-for-dutyfree/create/suspend-doc`, data)
	},
	getRequestDocs(payload) {
		return ApiService.post(`request-for-dutyfree/search`, payload)
	},
	deleteRequestDoc(id) {
		return ApiService.delete(`request-for-dutyfree/delete/${id}`)
	},
	updateRequestCount(data) {
		return ApiService.post(`request-for-dutyfree/update/request-item`, data)
	},
	getRequestDocById(id) {
		return ApiService.get(`/request-for-dutyfree/get/${id}`)
	},
	saveRequestDoc(status, id) {
		return ApiService.put(`/request-for-dutyfree/update/status/${status}/${id}`)
	},
	saveEndRequestDoc(docId) {
		return ApiService.post(`/request-for-dutyfree/create/transfer-docs/by-request-doc-id/${docId}`)
	},
	getRequestDocsForCounter(payload) {
		return ApiService.post(`/request-for-dutyfree/search/list/only-checking-docs`, payload)
	},
	getRequestTransferCreateListForCounter(data) {
		return ApiService.post(`/request-for-dutyfree/get/for-counters`, data)
	},
	getWithBarcode(id) {
		return ApiService.get(`${PREFIX}/get-with-barcode/${id}`)
	},
	updateItem(item) {
		return ApiService.put(`${ITEM_PREFIX}/edit/${item.id}`, item)
	},
	pending: (data) => {
		return ApiService.post(`${PREFIX}/pending-documents`, data)
	},
	getViewPRoductItems(obj) {
		return ApiService.post(`/item/list/wrapped-item/${obj.itemId}/${obj.departmentId}`)
	},
	pendingCount: () => {
		return ApiService.get(`${PREFIX}/pending-documents-count`)
	},
	editTransfer(data) {
		return ApiService.put(`${PREFIX}/edit-transfer/${data.id}`, data);
	},
	editTransferNew(data) {
		return ApiService.post(`${PREFIX}/edit-transfer/with-list`, data);
	},
	returnPending(docId) {
		return ApiService.post(`${PREFIX}/return/${docId}`, {});
	},
	updateWhItem(id, payload) {
		return ApiService.post(`wh-document-item/update/${id}`, payload);
	},
	updateWhItemWithDocIdAndItemId(payload) {
		return ApiService.post(`wh-document-item/with-doc-id-and-item-id/update`,  payload);
	},
	getDocumentForTransaction(data) {
		return ApiService.get(`${PREFIX}/available/documents-for-transaction`);
	},
	saveDocumentForTransfer(data) {
		return ApiService.post(`${PREFIX}/transfer/document`, data);
	},
	savePricingDoc(docId) {
		return ApiService.post(`${PREFIX}/pricing-doc/save-ready/${docId}`, {});
	},
	savePricingTransferDoc(docId) {
		return ApiService.post(`${PREFIX}/pricing/transfer-doc/save-ready/${docId}`, {});
	},
	getDocumentExcelWithPrices(docId) {
		return ApiService.get(`${PREFIX}/get-excel/with-prices/${docId}`, {});
	},
	uploadExcel(data) {
		return ApiService.post(`${PREFIX}/upload-excel/set-price`, data);

		// let bodyFormData = new FormData();
		// bodyFormData.append('upload', form.file)
		//
		// // var data = {
		// // 	departmentId: param.departmentId,
		// // 	nameLt: param.nameLt,
		// // 	nameRu: param.nameRu,
		// // 	nameUz: param.nameUz,
		// // }
		//
		// // var res = await ApiService.post(`${main}/create`, data)
		// var requestData = {
		// 	method: 'post',
		// 	url: `/warehouse-document/upload-excel/set-price`,
		// 	data: bodyFormData,
		// 	headers: {'Content-Type': 'multipart/form-data'}
		// };
		// try {
		// 	return await ApiService.customRequest(requestData);
		//
		// } catch (error) {
		// 	return error.response.data
		// }
	},
	/** ZAYAVKA **/

	saveRequest(payload) {
		return ApiService.post(`${ORDER_DOCUMENT}/create-or-update`, payload)
	},
	saveAndCreateRequest(payload) {
		return ApiService.post(`${ORDER_DOCUMENT}/save-and-send`, payload)
	},
	fetchRequests(payload) {
		return ApiService.post(`${ORDER_DOCUMENT}/list`, payload)
	},
	getOrderDocumentItemsList(docId) {
		return ApiService.get(`${ORDER_DOCUMENT}/get/${docId}`)
	},
	/** Zayavka end */

	/** Warehouse Items **/

	storeItem: (data) => {
		return ApiService.post(ITEM_PREFIX + '/create', data)
	},
	removeItem: (payload) => {
		return ApiService.post(`${ITEM_PREFIX}/delete-changed-department`, payload)
	},
	removeItemId(data, id) {
		return ApiService.post(`${ITEM_PREFIX}/delete/${id}`, data)
	},
	byDocument: (id) => {
		return ApiService.get(`${ITEM_PREFIX}/get-by-document/${id}`)
	},
	byDocumentForWriteOff: (id) => {
		return ApiService.get(`${ITEM_PREFIX}/get-by-document/for-transfer/${id}`)
	},
	byDocumentForTransfer: (id) => {
		return ApiService.get(`${ITEM_PREFIX}/get-by-document-by-transfer/for-transfer/${id}`)
	},

	/** Warehouse **/

	warehouse: (data) => {
		return ApiService.get(`${MAIN}/balance/${data.departmentId}`, {
			params: data
		})
	},

	balanceByItem(department, item) {
		return ApiService.get(`${MAIN}/balance-by-item/${department}/${item}`)
	},

	getBalanceItem(depId, itemId, type) {
		return ApiService.get(`${MAIN}/balance-item/${depId}/${itemId}/${type}`);
	},
	lastPriceOfItem(departmentId, itemId) {
		return ApiService.get(`/${PRICING_ITEM}/get/${departmentId}/${itemId}`)
	},
	getListByProductsNotKirimService(payload) {
		return ApiService.get(`/item/search-by-keyword-for-dep/${payload.keyword}/${payload.depId}`);
	},
	getListByProductsNotKirimServiceFunction(depId, keyword) {
		return ApiService.get(`/item/wh-search-for-dep/retail/${keyword}/${depId}`);
	},
	getListByProductsNotKirimServiceFunctionNew(depId, keyword) {
		return ApiService.get(`/item/wh-search-for-dep/discount/retail/${keyword}/${depId}`);
	},
	getTransferIncomeList(payload, depId) {
		return ApiService.post(`/warehouse-document/pending-before-pos-documents/${depId}`, payload)
	},
	getTransferList(payload, depId) {
		return ApiService.post(`/warehouse-document/search/transfer-kirim-before-pos/${depId}`, payload)
	},
	saveAllPendingItems(docId) {
		return ApiService.post(`/warehouse-document/receive/transfer-pending-doc/${docId}`)
	},
	getGoodFromBarcode(data) {
		return ApiService.get(`item-balance/list${data}`).then(response => response.data);
	},
	getGoodFromMultiBarcode(data) {
		return ApiService.get(`item-balance/print/barcode${data}`).then(response => response.data);
	},

	lessThanFiveExeption(data) {
		return ApiService.post(`item-balance/list/less-than-five/exception${data.link}`, [data.departments])
	},
	balancePrice(data) {
		if (data.selected == 'sklad') {
			return ApiService.get(`item-balance/list${data.link}`).then(response => response.data);
		} else {
			return ApiService.post(`item-balance/list/less-than-five${data.link}`, data.departments).then(response => response.data);
		}
	},
	itemBalance(data) {
		if (data.selected == 'sklad') {
			return ApiService.get(`item-balance/list/all-departments${data.link}&page=1&limit=10`).then(response => response.data);
		} else {
			return ApiService.post(`item-balance/list/less-than-five${data.link}`, data.departments).then(response => response.data);
		}
	},
	/**
	 * ADDED ON 19.02.2020 BY BAKHTIYOR
	 * GET ITEMS FOR WAREHOUSES (COUNTS ARE SUMED) REGARDLESS OF ITEMS' PRICES
	 * @param {string query} data
	 */
	getItemsListForWhGrid(data) {
		return ApiService.get(`item-balance/list-by-item${data.link}`).then(response => response.data);
	},
	forIdsent(data, itemId) {
		return ApiService.post(`item-balance/item-details?itemId=${itemId}`, data)
	},
	// GET ITEMS FOR ITEM-CONVERT
	getItemsForItemConvertService(data) {
		return ApiService.get(`item-balance/list-for-convert${data.link}`).then(response => response.data);
	},
	getDocList(data) {
		return ApiService.post(`warehouse-document/search/conversion-out`, data)
	},
	requestWarehouse(payload) {
		return ApiService.post(`/request/item-balance/list/item-id`, payload);

	},
	unConvert(depId, data) {
		return ApiService.post(`/wrapped-item/convertWrappedToUnwrapped/${depId}`, data)
	},
	getAllRequestPending(payload, selected) {
		if (selected == 'recieved') {
			return ApiService.post(`/request/received`, payload);
		} else if (selected == 'sended') {
			return ApiService.post(`/request/sended`, payload);
		} else if (selected == 'pending') {
			return ApiService.post(`/request/received/pending`, payload);

		}
	},
	recieveCreate(payload, id) {
		return ApiService.post(`/request/receive/create/${id}`, payload);
	},
	getByDocumentRequestPending(documentId) {
		return ApiService.post(`/request/request-item/list/${documentId}`);
	},
	requesWarehousetUpdate(payload) {
		return ApiService.post(`/request/edit`, payload);
	},
	createRequestDraft(status) {
		let obj = {}
		obj.status = status;
		return ApiService.post(`/request/create`, obj);
	},
	viewWarehouseRequest(items) {
		return ApiService.post(`/request/list/order-items`, items);

	},
	returnWhereHouse: (data) => {
		return ApiService.get(`${PREFIX}/return/${data.documentId}`, {
			params: data
		})
	},
	partial(documentId, data) {
		return ApiService.post(`${PREFIX}/partial/${documentId}`, data).then(response => response.data);
	},
	spisat(documentId, data) {
		return ApiService.post(`${PREFIX}/spisat/${documentId}`, data).then(response => response.data)
	},
	returnItemsService(documentId, data) {
		return ApiService.post(`${PREFIX}/return-partial/${documentId}`, data).then(response => response.data)
	},
	adjustmentAdd(data) {
		return ApiService.post(`adjustment/create`, data).then(response => response.data)
	},
	adjustmentEdit(data) {
		return ApiService.put(`adjustment/edit/${data.id}`, data).then(response => response.data)
	},
	getAdjList(data) {
		return ApiService.post(`adjustment/list`, data).then(response => response.data)
	},

	// Sector

	getSectorsList(data) {
		return ApiService.post(`sectors/sectors-list`, data).then(response => response.data)
	},

	createOrUpdateSector(data, mode) {
		if (mode) {
			return ApiService.put(`sectors/edit/${data.id}`, data).then(response => response.data);
		} else {
			return ApiService.post(`sectors/create`, data).then(response => response.data);
		}
	},
	getItemsBySectorId(data) {
		return ApiService.post(`sectors/list-sectors`, data).then(response => response.data);
	},

	getSectorByDepartmentId(data) {
		return ApiService.get(`sectors/get-by-department/${data}`).then(response => response.data)
	},
	deleteSector(data) {
		return ApiService.delete(`sectors/delete/${data}`).then(response => response)
	},

	changeSectors(data) {
		return ApiService.post(`/sectors/transfer-items`, data).then(response => response)
	},
	getSectorById(data) {
		return ApiService.get(`sectors/get/${data}`).then(response => response)
	},
	saveInvenotoryDocument(data, id) {
		return ApiService.post(`/warehouse-document/create-doc/inventory/${id}`, data).then(response => response)
	},
	getPendingIncomesFromManufactureApi(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/pack',
			baseURL: '/',
			data: payload
		}
		return ApiService.customRequest(config);
	},
	getPackList(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/list',
			baseURL: '/',
			data: payload
		}
		return ApiService.customRequest(config);
	},
	/* RECEIVE PENDING INCOME ITEMS */
	receivePendingIncome(payload) {
		return ApiService.post(`${PREFIX}/receive-pending-doc`, payload);
	},
	/* CHECK PENDING INCOME ITEMS */
	checkPendingIncomeItems(payload) {
		return ApiService.post(`${PREFIX}/check-pending-doc`, payload);
	},
	acceptByManufacturer(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/accepted',
			baseURL: '/',
			data: payload
		}
		return ApiService.customRequest(config);
	},
	getPendingIncomesCountService(payload) {
		let config = {
			method: 'POST',
			url: 'http://213.230.127.153:9000/api/v1/products/total-pack',
			baseURL: '/',
			data: payload
		}
		return ApiService.customRequest(config);
	},
	uploadExcelForIncome(payload) {
		return ApiService.post(`excel-parser/save-full-file/${payload.docId}`, payload.formData);
	},
	saveSaleLoad(payload) {
		return ApiService.post(`sale-load/create`, payload);
	},
	excelNakladnoyTransfer(docId) {
		return ApiService.get(`excel-parser/nakladnoy/${docId}`)
	},
	excelNakladnoyOptom(saleId, data, dep) {
		let url = null
		if (dep == "ROMANIA") {
			url = `/excel-parser/nakladnoy/optom/romania/${saleId}`
		}
		if (dep == "MOLDOVA") {
			url = `/excel-parser/nakladnoy/optom/${saleId}`
		}
		let config = {
			baseURL: process.env.VUE_APP_ROOT_API,
			method: 'POST',
			url: url,
			responseType: 'blob',
			headers: {
				'Authorization': `Bearer ${TokenService.getToken()}`,
			},
			data: data
		}

		return ApiService.customRequest(config)
	},
	getActiveDiscount(depId) {
		return ApiService.get(`${PREFIX}/get/active-discount/${depId}`);
	}

};

export default WhDocument;
